<template>
  <div class="store-audit">
  
    <employee-dialog v-model="employeeDialogMain" @select="setReviewApprove"></employee-dialog>
    <index-view title="Store audit" :filters="filters" :enableCreate="true"
      :getData="getData" 
      :getDetail="getDetail" 
      :createHandler="createHandler"
      :showActions="true"
      :headers="mainHeaders" 
      :detailWidth="1200" :cellSlots="cellSlots" tableKey="id">
      <template #viewSection="{ item, selected }" >
        <detail :item="item" :selected="selected"></detail>
      </template>
        
      <template v-slot:[`status`]="{ cell, reload }">
        <b :key="'status'" :class="convertStatus(cell?.status).color">{{ convertStatus(cell?.status).text }}</b>
    </template>
      
      <template v-slot:[`totalScoreNvm`]="{ cell, reload }">
        <span :class="cell?.totalScoreNvm == cell?.totalMaxScoreNvm && cell?.totalMaxScoreNvm>0 ? 'green--text' : ''">{{ cell?.totalScoreNvm }}/{{ cell?.totalMaxScoreNvm }}</span>
      </template>
      
      <template v-slot:[`keyEmployeeHireDate`]="{ cell, reload }">
        <span>{{ $formatter.formatDate(cell?.keyEmployeeHireDate, 'DD/MM/YYYY') }}</span>
      </template>
      
      <template v-slot:[`totalScoreCot2`]="{ cell, reload }">
        <span :class="cell?.totalScoreCot2 == cell?.totalMaxScoreCot2 && cell?.totalMaxScoreCot2>0 ? 'green--text' : ''">
          {{ cell?.totalScoreCot2 }}/{{ cell?.totalMaxScoreCot2 }}
        </span>
      </template>
      
      <template v-slot:[`approvedByCode`]="{ cell, reload }">
      <b>{{ cell?.approvedByCode }}</b>
      <p class="my-0 green--text"  @click="employeeDialogMain=true, selected = cell" style="cursor: pointer;"> <u><small>Thay đổi</small></u></p>
      </template>

    </index-view>
    
  </div>
</template>

<script>

import IndexView from '../../../components/CommonView/IndexView.vue';
import { get, getDetail,post, getFinal, removeFinal, getFinalSession, getReady, setReady, initReady, generateReview, changeConfirmedBy, changeApprovedBy } from './api'
import { main, readyHeaders } from './header'
import Detail from './Detail.vue'
import EmployeeDialog from '../../../components/Crud/Prompt/EmployeeDialog.vue';
import moment from 'moment';
const statusFilters = ['Tạo mới', 'Hoàn tất', 'Hủy']
export default {
  name: "CustomerReview",
  components: {
    IndexView,
    Detail,
    EmployeeDialog
  },
  computed: {
    mainHeaders () {
      return main(this.filters)
    },
    yearOptions() {
      let thisYear = moment().year();
      let lowerYear = thisYear - 5;
      let upperYear = thisYear + 5;
      var yearOptions = [];
      for(let y = lowerYear; y <= upperYear; y++) {
        yearOptions.push(y);
      }

      return yearOptions;
    }

  },
  data() {
    return {
      filters: [
        {name: 'id', label:'Id', type: 'text', value: '' },
        {name: 'keyEmployeeCode', label:'Mã NS', type: 'text', value: '' },
        {name: 'keyEmployeeName', label:'Tên NS', type: 'text', value: '' },
        // {name: 'status', label:'Trạng thái', type: 'select', selectItems: statusFilters, value: '' },
      ],
      cellSlots: ['status', 'approvedByCode', 'totalScoreNvm', 'totalScoreCot2', 'keyEmployeeHireDate'],
      selected: null,
      action1Dialog: false,
      actionData: {
        month: null
      },
      finals: [],
      sessionYear: moment().year(),

      action2Dialog: false,
      action2Calendar: null,
      readySearch: '',
      readies: [],
      readyHeaders: readyHeaders,
      readyLoading: false,

      employeeDialog: false,
      employeeDialogMain: false,
    }
  },
  watch: {
    action2Calendar(newVal) {
      this.getReady();
    },
    sessionYear(newVal) {
      this.getFinalSession();
    }
  },
  methods: {
    getData: get,
    getDetail: getDetail,
    createHandler: post,
    actionSubmit(item) {
      return setFinal(item.month).then(() =>{
        // this.action1Dialog = false;
      }).finally(() => {
        this.getFinalSession();
      })
    },
    actionRemove(item) {
      return removeFinal(item.month).then(() => {
        this.finals = this.finals.filter(i => i.month !== item.month)
      }).finally(() => {
        this.getFinalSession();
      })
    },
    getFinal() {
      return getFinal().then(data => {
        this.finals = data.data.map(item => {
          item.month = this.$formatter.formatDate(item.month, 'MM/YYYY')
          return item
        });
      })
    },

    getFinalSession() {
      return getFinalSession(this.sessionYear).then(data => {
        this.finals = data.data.map(item => {
          item.month = this.$formatter.formatDate(item.month, 'MM/YYYY')
          return item
        });
      })
    },

    //ready section
    getReady() {
      this.readyLoading =true
      return getReady(this.action2Calendar).then(data => {
        this.readies = data.data;
      }).finally(() => {
        this.readyLoading =false
      })
    },
    
    setReady() {
      //call api to set ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return setReady(this.action2Calendar).then(() => {
        this.getReady();
      })
    },
    setEmployee(value) {
      var empObj = value[0]
      if(value.length == 0) {
        return changeConfirmedBy(this.selected.id, '').then(() => {
          this.selected.smCode = ''
          this.selected.smName = ''
          this.employeeDialog = false
        }).finally(() => {
          this.selected = null
        })
      }else {
        return changeConfirmedBy(this.selected.id, empObj.code).then(() => {
          this.selected.smCode = empObj.code
          this.selected.smName = empObj.name
          this.employeeDialog = false
        }).finally(() => {
          this.selected = null
        })
      }
    },
    setReviewApprove(value) {
      var empObj = value[0]
      if(value.length == 0) {
        return changeApprovedBy(this.selected.id, null).then(() => {
            this.selected.approvedByCode = null
            this.selected.approvedByName = null
            this.employeeDialogMain = false
          }).finally(() => {
            this.selected = null
          })
      }else {
        return changeApprovedBy(this.selected.id, empObj.code).then(() => {
          this.selected.approvedByCode = empObj.code
          this.selected.approvedByName = empObj.name
          this.employeeDialogMain = false
        }).finally(() => {
          this.selected = null
        })
      }
    },
    
    initReady() {
      //call api to set ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return initReady(this.action2Calendar).then(() => {
        this.getReady();
      })
    },

    generateReview() {
      //call api to generate review for ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return generateReview(this.action2Calendar).then(() => {
        this.getReady();
      })
    },
    convertStatus(status) {
      if(status === 0) return {text:'Tạo mới', color:'cyan--text'}
      if(status === 1) return {text:'SM duyệt', color:'green--text'}
      if(status === 2) return {text:'Lưu trữ', color:'blue--text'}
      return {text:'Hủy', color:'red--text'}
    }
  },
  mounted() {
    // this.getFinal().then(d => {
    // });

    this.getFinalSession(2025)
  }
}
</script>